<template>
  <BaseDetailTable
      :item-list.sync="itemList"
      :height="height - 100"
      :columns="columnsImport"
      :left-cols="12"
      :show-select="true"
      :single-select="false"
      :item-row-background="importItemRowBackground"
  >
    <template v-slot:body.prepend="{ headers }">
      <tr class="drag-header">
        <th class="drag-header"></th>
        <th v-for="(header, index) in headers" class="drag-header" v-if="index > 0 && index <= 6">
          <v-row v-if="index >= 2 && index <= 3">
            <v-col cols="4"
                   :draggable="false"
                   @drop="onDropCopy($event, header)"
                   @dragover.prevent
                   @dragenter.prevent
                   class="px-0"
            >
              <v-icon
                  class="px-0 d-flex justify-center"
              >
                mdi-content-paste</v-icon>
            </v-col>
            <v-divider vertical></v-divider>
            <v-col cols="4"
                   :draggable="false"
                   @drop="onDropAdd($event, header)"
                   @dragover.prevent
                   @dragenter.prevent
                   class="px-0"
            >
              <v-icon
                  class="px-0 d-flex justify-center"
              >mdi-page-layout-sidebar-right
              </v-icon>
            </v-col>
            <v-divider vertical></v-divider>
            <v-col cols="4"
                   :draggable="false"
                   @drop="onDropLine($event, header)"
                   @dragover.prevent
                   @dragenter.prevent
                   class="px-0"
            >
              <v-icon
                  class="px-0 d-flex justify-center"
              >mdi-page-layout-footer
              </v-icon>
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col cols="12"
                   :draggable="false"
                   @drop="onDropCopy($event, header)"
                   @dragover.prevent
                   @dragenter.prevent
                   class="px-0"
            >
              <v-icon
                  class="px-0 d-flex justify-center"
              >mdi-content-paste
              </v-icon>
            </v-col>
          </v-row>
        </th>
        <th v-for="(header, index) in headers" class="drag-header"
            v-if="index > 6"
            :draggable="true"
            @dragstart="onStartDrag($event, header)"
        >
          <v-icon
              class="d-flex justify-center"
          >mdi-swap-horizontal-circle-outline
          </v-icon>
        </th>
      </tr>
    </template>
    <template v-slot:top="paramsDetailTable">
      <v-toolbar height="48" elevation="0">
        <v-spacer></v-spacer>
        <v-btn
            small
            class="mx-1"
            @click="actionAddClipboard()"
        >
          Paste from clipboard
        </v-btn>
      </v-toolbar>
    </template>
    <template v-slot:item.original_qty="{item}">
      <BaseFieldNumber v-model.number="item.original_qty" :clearable="false" class="mb-n6"
                       @input="checkColumns"></BaseFieldNumber>
    </template>
    <template v-slot:item.original_designator="{item}">
      <BaseFieldText v-model="item.original_designator" :clearable="false" rows="1" auto-grow
                     class="mb-n6 text-caption"></BaseFieldText>
    </template>
    <template v-slot:item.original_description="{item}">
      <BaseFieldText v-model="item.original_description" :clearable="false" rows="1" auto-grow
                     class="mb-n6 text-caption"></BaseFieldText>
    </template>
    <template v-slot:item.original_mpn="{item}">
      <BaseFieldString v-model="item.original_mpn" :clearable="false" class="mb-n6"
                       @input="checkColumns"></BaseFieldString>
    </template>
    <template v-slot:item.original_article="{item}">
      <BaseFieldString v-model="item.original_article" :clearable="false" class="mb-n6"
                       @input="checkColumns"></BaseFieldString>
    </template>
    <template v-slot:item.original_customer_article="{item}">
      <BaseFieldString v-model="item.original_customer_article" :clearable="false" class="mb-n6"
                       @input="checkColumns"></BaseFieldString>
    </template>
    <template v-slot:footer="{selectedItems}">
      <v-toolbar height="32" elevation="0">
        <v-btn small @click="$emit('cancel'); itemList = []">Cancel</v-btn>
        <v-spacer></v-spacer>
        <v-btn :disabled="selectedItems.length == 0" small @click="onImport(selectedItems)">
          Import
        </v-btn>
      </v-toolbar>
    </template>
  </BaseDetailTable>
</template>

<script>
import {v4 as uuidv4} from "uuid";
import ConfirmDialog from "@/components/Base/ConfirmDialog";
import BaseDetailTable from "@/components/Base/BaseDetailTable";
import BaseFieldNumber from "@/components/Base/BaseFieldNumber";
import BaseFieldString from "@/components/Base/BaseFieldString";
import BaseFieldText from "@/components/Base/BaseFieldText";


export default {
  name: 'CoreBomImportTable',
  props: {
    height: {type: [Number], default: 800},
  },

  components: {
    ConfirmDialog,
    BaseDetailTable,
    BaseFieldNumber,
    BaseFieldString,
    BaseFieldText,
  },

  computed: {},

  methods: {
    getCellsFromClipboard(readFullText) {
      // console.log('readFullText', readFullText)
      let clipboardArray = []
      if (readFullText.includes('"'))
        for (const [index, row] of readFullText.split('"').entries()) {
          if (index % 2)
            clipboardArray.push(row.replace(/(?<!^)\n/g, "<br>"))
          else
            clipboardArray.push(row)
          // console.log('row', row, index)
        }
      else
        clipboardArray = [readFullText]
      let formatCellText = clipboardArray.join('"')
      // console.log('formatCellText', clipboardArray, formatCellText)
      let resultArray = []
      for (const row of formatCellText.split('\n')) {
        // console.log('row', row)
        const cells = row.split('\t')
        let line = []
        for (let cell of cells) {
          line.push(cell.replaceAll('<br>', '\n').replaceAll('"', ''))
        }
        resultArray.push(line)
      }
      // console.log('resultArray', resultArray)
      return resultArray
    },
    async actionAddClipboard() {
      if (navigator.clipboard == null) {
        this.flagError = true
        this.errorMessage = "This requires a secure origin — either HTTPS or localhost (or disabled by running Chrome with a flag).\n\n" +
            "In chrome://flags, enable 'Insecure origins treated as secure' and give it the origin you want."
        return
      }

      const readFullText = await navigator.clipboard.readText()
      // console.log('readFullText', readFullText)
      const clipboardArray = this.getCellsFromClipboard(readFullText)
      // console.log('clipboardArray', clipboardArray)

      for (const lineArray of clipboardArray) {
        // console.log('add row', lineArray)
        let new_bom_sheet = {
          uid: uuidv4(),
          qty: null,
          designator: null,
          original_description: null,
          original_mpn: null,
          article: null,
          customer_article: null,
          deleted: false,
        }
        for (const [index, column] of lineArray.entries())
          new_bom_sheet['c' + index] = column
        this.itemList.push(new_bom_sheet)
      }
      this.checkColumns()
    },
    importItemRowBackground(item) {
      // console.log('itemRowBackground', item)
      if (!item.isSelectable)
        return 'red lighten-5'
    },
    onStartDrag(event, header) {
      // console.log('onStartDrag', event, event.ctrlKey, header)
      event.dataTransfer.effectAllowed = 'copy'
      event.dataTransfer.setData('header_value', header.value)
    },
    onDropCopy(event, header) {
      let transfer_header_value = event.dataTransfer.getData('header_value')
      // console.log('onDrop', event, header.value, transfer_header_value)
      for (let row of this.itemList) {
        row[header.value] = row[transfer_header_value]
      }
      this.checkColumns()
      // console.log('onDrop end', this.itemList)
    },
    onDropAdd(event, header) {
      let transfer_header_value = event.dataTransfer.getData('header_value')
      console.log('onDropAdd', event, header.value, transfer_header_value)
      for (let row of this.itemList) {
        if (row[header.value] !== null)
          row[header.value] = row[header.value] + ' ' + row[transfer_header_value].replaceAll('\n', ' ')
        else
          row[header.value] = row[transfer_header_value]
      }
      this.checkColumns()
      // console.log('onDrop end', this.itemList)
    },
    onDropLine(event, header) {
      let transfer_header_value = event.dataTransfer.getData('header_value')
      // console.log('onDrop', event, header.value, transfer_header_value)
      for (let row of this.itemList) {
        if (row[header.value] !== null)
          row[header.value] = row[header.value] + '\n' + row[transfer_header_value]
        else
          row[header.value] = row[transfer_header_value]
      }
      this.checkColumns()
      // console.log('onDrop end', this.itemList)
    },
    onImport(selectedItems) {
      // console.log('onImport', selectedItems)
      this.$emit('import', selectedItems);
      this.itemList = []
    },
    checkColumns() {
      // console.log('checkColumns', this.itemList)
      for (let row of this.itemList) {
        row.isSelectable = !isNaN(parseInt(row.original_qty))
            // && (row.customer_article === null || row.customer_article === '' || row.customer_article === undefined)
        if (!isNaN(parseInt(row.original_qty)))
          row.original_qty = parseInt(row.original_qty)
        else row.original_qty = null
        // console.log('error', row)
      }
    },
  },

  async mounted() {
    this.itemList = []

  }
  ,

  data() {
    return {
      itemList: [
        // {uid: uuidv4(), qty:1, description: 'desc1', customer_article: 'ca1', article: 'a1'},
        // {uid: uuidv4(), qty:2, description: 'desc2', customer_article: 'ca2', article: 'a2'},
      ],
      columnsImport: [
        {text: 'QTY', value: 'original_qty', sortable: false, filterable: true, divider: true, width: 70},
        {text: 'Designator', value: 'original_designator', sortable: false, filterable: true, divider: true, width: 200},
        {
          text: 'Description',
          value: 'original_description',
          sortable: false,
          filterable: true,
          divider: true,
          width: 400
        },
        {text: 'MPN', value: 'original_mpn', sortable: false, filterable: true, divider: true, width: 200},
        {text: 'Article', value: 'original_article', sortable: false, filterable: true, divider: true, width: 80},
        {
          text: 'Customer article',
          value: 'original_customer_article',
          sortable: false,
          filterable: true,
          divider: true,
          width: 20
        },
        {text: 'C0', value: 'c0', sortable: false, filterable: true, divider: true, width: 20},
        {text: 'C1', value: 'c1', sortable: false, filterable: true, divider: true, width: 20},
        {text: 'C2', value: 'c2', sortable: false, filterable: true, divider: true, width: 20},
        {text: 'C3', value: 'c3', sortable: false, filterable: true, divider: true, width: 20},
        {text: 'C4', value: 'c4', sortable: false, filterable: true, divider: true, width: 20},
        {text: 'C5', value: 'c5', sortable: false, filterable: true, divider: true, width: 20},
        {text: 'C6', value: 'c6', sortable: false, filterable: true, divider: true, width: 20},
        {text: 'C7', value: 'c7', sortable: false, filterable: true, divider: true, width: 20},
        {text: 'C8', value: 'c8', sortable: false, filterable: true, divider: true, width: 20},
      ],
    }
  }
}
</script>

<style>
.no-spin input[type='number'] {
  -moz-appearance: textfield;
  /*width: 50px;*/
}

.drag-header {
  padding: 0px;
  height: 36px !important;
  border-right: thin solid rgba(0, 0, 0, .12);
  /*border-style: solid;*/
  /*border-width: thin;*/
}
</style>

<i18n>
{
}
</i18n>
